
export function initModals() {
  document.addEventListener("click", (e) => {
    const trigger = e.target.closest('[rel="modal:open"]')
    if (trigger) {
      const id = (trigger.getAttribute("href") || "").replace(/^.*#/, "")
      const dialog = id && document.getElementById(id)

      if (dialog instanceof HTMLDialogElement) {
        e.preventDefault()
        dialog.showModal()
      }
      return
    }

    const close = e.target.closest("[data-dialog-close]")
    if (close) {
      close.closest("dialog")?.close()
      return
    }

    if (e.target instanceof HTMLDialogElement && e.target.open) {
      e.target.close()
    }
  })

  const target = window.location.hash && document.getElementById(window.location.hash.slice(1))
  if (target instanceof HTMLDialogElement) target.showModal()
}
